// extracted by mini-css-extract-plugin
export var caretAnchor = "_ut-0";
export var dropdownContent = "_ut-1";